// Phone / WhatsApp contact is temporarily hidden site-wide. Set to true to restore.
export const SHOW_PHONE_CONTACT = false;

export const PHONE_DISPLAY = "+92 322 8405321";
export const WHATSAPP_URL = "https://wa.me/923228405321";
